export function safeExternalUrl(value: string | undefined): string {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return '';
  try {
    return ['https:', 'http:'].includes(new URL(trimmed).protocol) ? trimmed : '';
  } catch {
    return '';
  }
}

export function safeSameOriginOrHttpImageUrl(value: string | undefined): string {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return '';
  if (safeExternalUrl(trimmed)) return trimmed;
  if (!['/', './', '../'].some(prefix => trimmed.startsWith(prefix))) return '';

  try {
    const parsed = new URL(trimmed, window.location.origin);
    if (parsed.origin === window.location.origin && ['http:', 'https:'].includes(parsed.protocol)) return trimmed;
  } catch {
    return '';
  }

  return '';
}

export function isTrustedHttpsHostUrl(value: string | undefined, expectedHost: string): boolean {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return false;
  try {
    const parsed = new URL(trimmed);
    return parsed.protocol === 'https:' && parsed.hostname === expectedHost;
  } catch {
    return false;
  }
}